import { CssBaseline, ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { themeSettings } from "theme";
import Layout from "scenes/layout";
import Dashboard from "scenes/dashboard";
import Properties from "scenes/properties";
import Owner from "scenes/owners/owner";
import Unit from "scenes/units";
import ExpenseType from "scenes/expense-type";
import ContractRegistration from "scenes/contract";
import Tenants from "scenes/tenants";
import Login from "scenes/login";
import Receipt from "scenes/receipt";
import ExpenseHistory from "scenes/expense-history";
import Report from "scenes/report";
import Search from "scenes/search/Search";
import Role from "scenes/roles/role";
import User from "scenes/users/User";
import VoucherReceipts from "scenes/voucherReceipts/VoucherReceipts";
import RentDispute from "scenes/rent-dispute";
import CommonExpenseHistory from "scenes/common-expense/Index";
import ChangePassword from "scenes/change-password/ChangePassword";
import Employee from "scenes/employee";
import PaymentVoucher from "scenes/paymentVoucher/PaymentVoucher";
import Snapshot from "scenes/snapshot";
import SoldProperties from "scenes/sold-properties";

function App() {
    const mode = useSelector((state) => state.global.mode);
    const theme = useMemo(() => createTheme(themeSettings(mode)), [mode]);
    const token = localStorage.getItem("token");

    return (
        <div className="app">
            <BrowserRouter basename="/">
                <ThemeProvider theme={theme}>
                    <CssBaseline />
                    <Routes>
                        {token ? (
                            <Route path="/" element={<Navigate to="/dashboard" replace />} />
                        ) : (
                            <Route path="/" element={<Navigate to="/login" replace />} />
                        )}
                        <Route path="/login" element={<Login />} />
                        <Route element={<Layout />}>
                            <Route path="/dashboard" element={<Dashboard />} />
                            <Route path="/roles" element={<Role />} />
                            <Route path="/users" element={<User />} />
                            <Route path="/owners" element={<Owner />} />
                            <Route path="/properties" element={<Properties />} />
                            <Route path="/units" element={<Unit />} />
                            <Route path="/expense-types" element={<ExpenseType />} />
                            <Route path="/contract" element={<ContractRegistration />} />
                            <Route path="/tenants" element={<Tenants />} />
                            <Route path="/receipts" element={<Receipt />} />
                            <Route path="/expenses" element={<ExpenseHistory />} />
                            <Route path="/report" element={<Report />} />
                            <Route path="/search" element={<Search />} />
                            <Route path="/common-expense" element={<CommonExpenseHistory />} />
                            <Route path="/voucher-receipts" element={<VoucherReceipts />} />
                            <Route path="/rent-dispute" element={<RentDispute />} />
                            <Route path="/change-password" element={<ChangePassword />} />
                            <Route path="/employee" element={<Employee />} />
                            <Route path="/payment-voucher" element={<PaymentVoucher />} />
                            <Route path="/position-reports" element={<Snapshot />} />
                            <Route path="/sold-properties" element={<SoldProperties />} />
                        </Route>
                    </Routes>
                </ThemeProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
